import FAQItem from '../../components/items/FAQItem'

function FAQList() {
  return (
    <ul>
        <FAQItem />
        <FAQItem />
        <FAQItem />
        <FAQItem />
        <FAQItem />
        <FAQItem />
        <FAQItem />
        <FAQItem />
    </ul>
  )
}

export default FAQList